export const sassVarToNumber = (sassVar: string): number => {
  const numberPattern = /\d+/g
  return Number((sassVar || '0').match(numberPattern)?.[0])
}
